import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import * as authApi from '../api/auth';

export const VerifyEmail: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Invalid verification link');
      return;
    }
    authApi.verifyEmail(token)
      .then(() => {
        setStatus('success');
        setMessage('Email verified successfully');
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err?.response?.data?.detail || 'Verification failed');
      });
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md p-8 bg-white rounded-lg shadow text-center">
        {status === 'loading' && <p>Verifying your email...</p>}
        {status === 'success' && (
          <>
            <h2 className="text-2xl font-bold mb-4 text-green-600">{message}</h2>
            <Link to="/login" className="text-blue-600 hover:underline">Log in to your account</Link>
          </>
        )}
        {status === 'error' && (
          <>
            <h2 className="text-2xl font-bold mb-4 text-red-600">Verification Failed</h2>
            <p className="text-gray-600 mb-4">{message}</p>
            <Link to="/login" className="text-blue-600 hover:underline">Back to login</Link>
          </>
        )}
      </div>
    </div>
  );
};